import React from 'react';
import {
  DialogTitle,
  Button,
  DialogActions,
  DialogContent,
  TextField,
  Grid,
  LinearProgress
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import Dialog from '../Dialog';
import { inputFieldNames } from '../../constants';

import { DatePicker } from '../DatePicker';

const useStyles = makeStyles((theme) => ({
  dialog: {},
  dialogTitle: {
    background: '#f0f0f0'
  },
  dialogContent: {
    width: 580,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(3)
  },
  actionButton: {
    width: 180,
    float: 'right',
    margin: theme.spacing(2)
  },
  footer: {
    background: '#f0f0f0'
  },
  multilineTextBox: {
    marginTop: 20
  },
  picker: {
    margin: 0,
    padding: 0
  },
  validationFail: {
    color: 'red'
  }
}));

const CreateEditPersonnelFormUI = (props) => {
  const classes = useStyles();
  const {
    openDialog,
    openCreatePersonnelDialog,
    onHandleInputChange,
    personnel,
    isSaving,
    handleSubmit,
    title,
    actionButtonText = 'Add',
    validationState,
    isShort
  } = props;

  const onDialogClose = () => {
    openCreatePersonnelDialog(false);
  };

  const showAllField = isShort === false || typeof isShort === 'undefined';

  const handleInputChange = (e, inputfieldName) => {
    if (e) {
      if (
        inputfieldName === inputFieldNames.ASSIGNEE ||
        inputfieldName === inputFieldNames.REQUESTOR
      ) {
        onHandleInputChange(e.target.checked, inputfieldName);
      } else if (
        inputfieldName === inputFieldNames.START_DATE_UTC ||
        inputfieldName === inputFieldNames.REG_DATE_UTC
      ) {
        onHandleInputChange(e && e.format('YYYY-MM-DD'), inputfieldName);
      } else {
        onHandleInputChange(e.target.value, inputfieldName);
      }
    }
  };

  return (
    <React.Fragment>
      <Dialog
        open={openDialog}
        onClose={onDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
      >
        {isSaving ? <LinearProgress /> : ''}
        <DialogTitle id="alert-dialog-title" className={classes.dialogTitle}>
          {title}
        </DialogTitle>
        <form onSubmit={handleSubmit}>
          <DialogContent className={classes.dialogContent}>
            <Grid container className={classes.formContainer} spacing={4}>
              <Grid item xs={6}>
                <TextField
                  required
                  id="personnelFirstName"
                  label="First Name"
                  onChange={(e) =>
                    handleInputChange(e, inputFieldNames.FIRST_NAME)
                  }
                  value={personnel.firstName}
                  fullWidth
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  required
                  id="personnelLastName"
                  label="Last Name"
                  onChange={(e) =>
                    handleInputChange(e, inputFieldNames.LAST_NAME)
                  }
                  value={personnel.lastName}
                  fullWidth
                />
              </Grid>

              {validationState === false ? (
                <Grid item xs={12}>
                  <span className={classes.validationFail}>Duplicate name</span>
                </Grid>
              ) : (
                ''
              )}
             
              { showAllField ? 
                <div> 
              <Grid item xs={6}>
               <DatePicker
                 id="personnelStartDate"
                 htmlId="personnelStartDate"
                 title="Start Date"
                 className={classes.picker}
                 handleDateChange={(date) =>
                   handleInputChange(date, inputFieldNames.START_DATE_UTC)
                 }
                 selectedDate={personnel.startDateUTC}
               />
             </Grid>
             <Grid item xs={12} className={classes.multilineTextBox}>
               <TextField
                 id="noteId"
                 label="Notes"
                 multiline
                 rows={3}
                 fullWidth
                 variant="outlined"
                 onChange={(e) => handleInputChange(e, inputFieldNames.NOTES)}
                 value={personnel.notes}
               />
             </Grid> </div> : null
             
              }
             
            </Grid>
          </DialogContent>
          <DialogActions className={classes.footer}>
            <Button
              onClick={onDialogClose}
              color="primary"
              variant="outlined"
              className={classes.actionButton}
              id="cancelButton"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              color="primary"
              variant="contained"
              className={classes.actionButton}
              id="addChildButton"
              // disabled={!enableAddButton}
            >
              {actionButtonText}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </React.Fragment>
  );
};

export default CreateEditPersonnelFormUI;
